var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.89192 12.2081L8.53649 17.35C9.04501 17.35 9.26525 17.1254 9.52936 16.8556L11.9135 14.5121L16.8536 18.2331C17.7596 18.7525 18.398 18.479 18.6424 17.3758L21.8851 1.74752L21.886 1.7466C22.1733 0.369035 21.4016 -0.169651 20.5189 0.168294L1.45844 7.67397C0.157598 8.19332 0.177294 8.93919 1.2373 9.27714L6.11029 10.8361L17.4293 3.55142C17.962 3.18861 18.4463 3.38936 18.0479 3.75216L8.89192 12.2081Z","fill":"currentColor"}));
}

Telegram.defaultProps = {"width":"22","height":"19","viewBox":"0 0 22 19"};

module.exports = Telegram;

Telegram.default = Telegram;
